import {
	CheckUserWordsRequest,
	CheckUserWordsResponse,
	GetSavedWordsRequest,
	GetSavedWordsResponse,
	GetUserWordsRequest,
	GetUserWordsResponse,
	GetWordStatsRequest,
	GetWordStatsResponse,
	GetWordsToRepeatRequest,
	GetWordsToRepeatResponse,
	RecordQuizAttemptRequest,
	RecordQuizAttemptResponse,
	RemoveUserWordRequest,
	SaveUserWordRequest,
	SaveUserWordResponse
} from '../dto/user-words';
import { httpArg, httpGet, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

/**
 * Service for managing user's word collection and FSRS (spaced repetition) cards.
 */
@httpRoute('/api/user-words')
export abstract class IUserFsrsCardService {
	/**
	 * Save a word to user's collection
	 */
	@httpPost('save-word')
	saveUserWord(
		@httpArg('request') request: SaveUserWordRequest,
		@httpUserId() userId?: string
	): Promise<SaveUserWordResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Get user's saved words with pagination
	 */
	@httpGet('get-words')
	getUserWords(
		@httpArg('request') request: GetUserWordsRequest,
		@httpUserId() userId?: string
	): Promise<GetUserWordsResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Get words that are due for review/repetition
	 */
	@httpGet('get-words-to-repeat')
	getWordsToRepeat(
		@httpArg('request') request: GetWordsToRepeatRequest,
		@httpUserId() userId?: string
	): Promise<GetWordsToRepeatResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Record a quiz attempt for a word (updates FSRS scheduling)
	 */
	@httpPost('record-quiz-attempt')
	recordQuizAttempt(
		@httpArg('request') request: RecordQuizAttemptRequest,
		@httpUserId() userId?: string
	): Promise<RecordQuizAttemptResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Get statistics for a specific word
	 */
	@httpGet('get-word-stats')
	getWordStats(
		@httpArg('request') request: GetWordStatsRequest,
		@httpUserId() userId?: string
	): Promise<GetWordStatsResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Get all saved words (alternative method)
	 */
	@httpGet('get-saved-words')
	getSavedWords(
		@httpArg('request') request: GetSavedWordsRequest,
		@httpUserId() userId?: string
	): Promise<GetSavedWordsResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Remove a word from user's collection
	 */
	@httpPost('remove-word')
	removeUserWord(
		@httpArg('request') request: RemoveUserWordRequest,
		@httpUserId() userId?: string
	): Promise<boolean> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Check which word IDs are saved in user's collection
	 */
	@httpPost('check-words')
	checkUserWords(
		@httpArg('request') request: CheckUserWordsRequest,
		@httpUserId() userId?: string
	): Promise<CheckUserWordsResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}
}
